import styled from "styled-components";

export const EmailScribanValidationErrorUnorderedList = styled.ul`
    &&& {
        list-style-type: circle;
        display: block;
        list-style-type: disc;
        margin-top: 1em;
        margin-bottom: 1 em;
        margin-left: 0;
        margin-right: 0;
        padding-left: 40px;
        margin: 0px;
    }
`;

export const EmailScribanValidationErrorListItem = styled.li`
    &&& {
        display: list-item;
        padding-bottom: 10px;
        font-size: 14px;
        &:last-child{
            padding-bottom: 15px;
        }
    }
`;
